import React from 'react';
import { BaseLayerView } from '@/framework';
import { IMediaLayerProps, IRenderLayerProps, MediaType } from '@/version-types';
import MediaImage from './media-image';
import MediaVideo from './media-video';

const MediaLayer: React.FC<IRenderLayerProps> = ({ layer, isNavigator }) => {
    const { mediaType } = layer.data as IMediaLayerProps;
    return (
        <>
            <BaseLayerView isNavigator={isNavigator} layer={layer}>
                {mediaType === MediaType.Video ? <MediaVideo layer={layer} /> : <MediaImage layer={layer} />}
            </BaseLayerView>
        </>
    );
};
export default React.memo(MediaLayer);
